"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.log = void 0;
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var isInIframe = window.top !== window.self;
var windowObj = isInIframe ? window : window.top;
var log = windowObj.location.href.includes('showLogs=true') ? console.log.bind(window.console) : function () {};
exports.log = log;